import React, { useEffect, useState } from "react";
import "./index.scss";
import PageHeader from "../../../adminCompenents/listComponents/Layout";
import CardContainer from "../../../adminCompenents/listComponents/UI/CardContainer";
import ExportButton from "../../../adminCompenents/listComponents/UI/ExportButton";
import AddButton from "../../../adminCompenents/listComponents/UI/AddButton";
import SearchFilterBar from "../../../adminCompenents/listComponents/UI/SearchFilterBar";
import DataTable from "../../../adminCompenents/listComponents/UI/DataTable";
import DataCards from "../../../adminCompenents/listComponents/UI/DataCards";
import Pagination from "../../../adminCompenents/listComponents/UI/Pagination";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { showSuccessToaster } from "../../../adminCompenents/listComponents/UI/toaster/success";
import { exportCSV } from "../../../adminCompenents/utils";
import DrawerForm from "../../../adminCompenents/listComponents/UI/DrawerForm";

const NewslettersPage = () => {
  const [newsletters, setNewsletters] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const perPage = 5;
  const [filters, setFilters] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [editNewsletter, setEditNewsletter] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);

  // 👉 Responsive
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 👉 Charger données
  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await fetch("https://api.almasecret.msit-demo.fr/newsletter");
      const data = await res.json();
      setNewsletters(Array.isArray(data) ? data : data.data || []);
    } catch (error) {
      showErrorToaster("Erreur lors du chargement des newsletters");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // 👉 Filtrage
  const filtered = newsletters.filter((n) => {
    return (
      n.email?.toLowerCase().includes(search.toLowerCase()) &&
      (filters?.email
        ? n.email.toLowerCase().includes(filters.email.toLowerCase())
        : true)
    );
  });

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice((page - 1) * perPage, page * perPage);

  // 👉 Colonnes du tableau
  const columns = [
    {
      header: "Email",
      accessor: "email",
    },
    {
      header: "Date d'inscription",
      accessor: "createdAt",
      Cell: (value) =>
        value ? new Date(value).toLocaleDateString("fr-FR") : "-",
    },
  ];

  // 👉 Actions par ligne
  const rowActions = (row) => [
    {
      label: "Supprimer",
      onClick: async () => {
        if (
          window.confirm("Êtes-vous sûr de vouloir supprimer cet abonnement ?")
        ) {
          try {
            const res = await fetch(
              `https://api.almasecret.msit-demo.fr/newsletter/${row._id}`,
              { method: "DELETE" }
            );
            if (res.ok) {
              setNewsletters((prev) => prev.filter((n) => n._id !== row._id));
              showSuccessToaster("Abonnement supprimé avec succès");
            } else {
              showErrorToaster("Erreur lors de la suppression");
            }
          } catch {
            showErrorToaster("Erreur de connexion");
          }
        }
      },
    },
  ];

  // 👉 Champs drawer (optionnel si tu veux ajouter un abonné manuellement)
  const fields = [
    {
      name: "email",
      label: "Email",
      type: "email",
      placeholder: "Entrez l'email",
      required: true,
    },
  ];

  const handleSubmit = async (formData, editNewsletter = null) => {
    try {
      if (editNewsletter) {
        // édition (rare pour newsletter)
      } else {
        // création
        const res = await fetch("https://api.almasecret.msit-demo.fr/newsletter", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        if (res.ok) {
          const newN = await res.json();
          setNewsletters((prev) => [...prev, newN]);
          showSuccessToaster("Abonnement ajouté avec succès");
        } else {
          showErrorToaster("Erreur lors de la création");
        }
      }
      setShowDrawer(false);
      setEditNewsletter(null);
    } catch (err) {
      showErrorToaster("Erreur de connexion");
    }
  };

  // 👉 Filtres
  const filterFields = [
    { name: "email", label: "Email", placeholder: "Search email..." },
  ];

  return (
    <div>
      <PageHeader
        title="Newsletters"
        breadcrumb={[{ label: "Accueil", href: "/" }, { label: "Newsletters" }]}
      />

      <CardContainer>
        <div className="d-flex justify-content-between align-items-center mb-3 m-4">
          <h5 className="title-liste">Liste des abonnés</h5>
          <div className="d-flex gap-2">
            <ExportButton
              onClick={() => {
                exportCSV(["email", "createdAt"], paginated, "newsletters.csv");
              }}
            />
            <AddButton label="Abonné" onClick={() => setShowDrawer(true)} />
          </div>
        </div>

        <hr className="hr-table" />
        <SearchFilterBar
          fields={filterFields}
          onSearch={setSearch}
          onFilter={(f) => setFilters(f)}
        />
        <hr className="hr-table" />

        {/* Responsive */}
        {isMobile ? (
          <DataCards
            columns={columns}
            data={paginated}
            keyField="_id"
            rowActions={rowActions}
          />
        ) : (
          <DataTable
            columns={columns}
            data={paginated}
            keyField="_id"
            rowActions={rowActions}
          />
        )}

        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </CardContainer>

      {/* Drawer Form */}
      <DrawerForm
        show={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setEditNewsletter(null);
        }}
        title={
          editNewsletter ? "Modifier un abonné" : "Ajouter un nouvel abonné"
        }
        fields={fields}
        initialData={editNewsletter}
        onSubmit={(data) => handleSubmit(data, editNewsletter)}
      />
    </div>
  );
};

export default NewslettersPage;
